const ORDER_FORMS: readonly [string, string, string] = [
  'новый заказ',
  'новых заказа',
  'новых заказов'
];

/**
 * Возвращает корректную форму подписи «новый заказ» с учётом русского
 * склонения по числу. Само число в строку не включается.
 *
 * @param count - количество новых заказов
 * @returns склонённая подпись без числа (напр. «новых заказа»)
 */
export const getNewOrdersLabel = (count: number): string => {
  const absCount = Math.abs(count) % 100;
  const lastDigit = absCount % 10;

  if (absCount > 10 && absCount < 20) {
    return ORDER_FORMS[2];
  }
  if (lastDigit > 1 && lastDigit < 5) {
    return ORDER_FORMS[1];
  }
  if (lastDigit === 1) {
    return ORDER_FORMS[0];
  }
  return ORDER_FORMS[2];
};
